import { connect } from 'react-redux'
import UserWidget from './UserWidget'
import { logout } from './../../../store/token/actions'

const mapStateToProps = (state) => ({
  avatarUrl: state.user.avatarUrl,
  name: state.user.name,
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserWidget)


// WEBPACK FOOTER //
// ./src/modules/ControlBar/UserWidget/Container.js